var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmParking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0714 0H1.92857C0.863839 0 0 0.785308 0 1.75325V14.6104C0 15.5783 0.863839 16.3636 1.92857 16.3636H16.0714C17.1362 16.3636 18 15.5783 18 14.6104V1.75325C18 0.785308 17.1362 0 16.0714 0ZM9.64286 10.5195H7.71429V12.2727C7.71429 12.5942 7.425 12.8571 7.07143 12.8571H5.78571C5.43214 12.8571 5.14286 12.5942 5.14286 12.2727V4.09091C5.14286 3.76948 5.43214 3.50649 5.78571 3.50649H9.64286C11.7683 3.50649 13.5 5.08076 13.5 7.01299C13.5 8.94521 11.7683 10.5195 9.64286 10.5195ZM9.64286 5.84416H7.71429V8.18182H9.64286C10.35 8.18182 10.9286 7.65584 10.9286 7.01299C10.9286 6.37013 10.35 5.84416 9.64286 5.84416Z",
    fill: "url(#paint0_linear_498_37225)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_498_37225",
    x1: 18,
    y1: 16.3636,
    x2: -1.48195,
    y2: 14.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8264F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmParking);
export default __webpack_public_path__ + "static/media/am-parking.74ba14ea54114b03191f47c0c29f3bb7.svg";
export { ForwardRef as ReactComponent };